import { ReportSummaryTiles } from '@equinoxx/react'
import MainLayout from '../components/MainLayout'

interface PageIndexProps { }
const PageIndex = function (props: PageIndexProps) {
    return (
        <MainLayout pageTitle="Home">
            <ReportSummaryTiles
                apiPrefix="continuum-bi/"
                linkGenerator={(report) => `/reports/${report.id}?workspaceId=${report.workspaceID}`}
            />
        </MainLayout>
    )
}
export { PageIndex as default }
